import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    sv: {
        translation: {
            "contact": "Kontakta oss",
            "sell": "Sälj med oss",
            "soldObjects": "Sålda objekt",
            "heroTitle": "NÄSTA KAPITEL BÖRJAR HÄR",
            "heroSubtitle": "VI HJÄLPER DIG HITTA MER ÄN BARA ETT HUS - VI HITTAR DITT HEM",
            "ourHomes": "Våra hem",
            "findHomeWhereLifeHappens": "HITTA HEM DÄR LIVET HÄNDER",
            "homeDescription": "Vi hjälper dig hitta en plats att trivas på. Vi förmedlar både privata och kommersiella objekt och hjälper dig att hitta rätt – oavsett om du söker ett hem, en investering eller nya lokaler för din verksamhet.",
            "moreProperties": "SE FLER HEM",
            "callConfirmation": "Vill du ringa det här numret?",
            "companyLogoAlt": "Företagslogga",
            "teamMemberName": "Peter Olvsborn",
            "teamMemberLabel": "Fastighetsmäklare",
            "teamMemberTitle": "Reg. Fastighetsmäklare",
            "teamMemberPhone": "Tel: +46 (0) 708-240472",
            "teamReadMore": "Läs mer om Peter",

            "info3Title": "VARJE HEM ÄR UNIKT",
            "info3Label": "Rådgivning",

            "info3Paragraph1": "och förtjänar att visas från sin bästa sida. Med rätt förberedelser kan du höja värdet och skapa bästa förutsättningar inför försäljning. God framförhållning ger utrymme att planera och få råd från en mäklare inför visning. Styling, professionella bilder och små förbättringar som målning eller nya lister kan göra stor skillnad utan stora kostnader.",
            "info3Paragraph2": "Att veta vilka förbättringar som faktiskt lönar sig kräver både erfarenhet och lokalkännedom. Vi guidar dig genom allt från möbleringstips till tankar kring rumsindelning för att ditt hem ska presenteras från sin absolut bästa sida. Vi finns här för att svara på dina frågor – kontakta oss redan idag för en kostnadsfri värdering och strategisk rådgivning anpassad efter just dina behov.",

            "footerLogoAlt": "Logotyp Din Mäklare",
            "aboutUs": "OM OSS",
            "phone": "Telefon",
            "email": "E-post",
            "address": "Adress",
            "addressText": "Köpmannagatan 15, 296 31 Åhus",
            "quickLinks": "SNABBLÄNKAR",
            "home": "Hem",
            "sellWithUs": "Sälj med oss",
            "socialMedia": "SOCIALA MEDIER",
            "footerCopyright": "© 2026 Din Mäklare Åhus & Österlen. Alla rättigheter förbehållna.",
            "currentProperties": "VÅRA AKTUELLA OBJEKT",
            "exploreProperties": "Utforska vårt utbud av bostäder – hitta ditt drömhem idag.",
            "comingSoon": "KOMMANDE",
            "soldProperties": "SÅLDA OBJEKT",
            "rooms": "Rum",
            "contactUs": "KONTAKTA OSS",
            "contactHeroText": "Vi finns här för att hjälpa dig med allt som rör din bostadsaffär.",
            "aboutUsText": "Vi är en lokal mäklarfirma med hjärtat i Åhus och många års samlad erfarenhet av den lokala fastighetsmarknaden. Vårt mål är att göra din bostadsresa så smidig, trygg och minnesvärd som möjligt. Med en kombination av modern marknadsföring, ett brett kontaktnät och en genuin fingertoppskänsla ser vi till att du får ut det bästa värdet av din bostad, samtidigt som vi hjälper dig att hitta rätt plats där nästa kapitel i livet kan börja.",
            "message": "Meddelande",
            "messagePlaceholder": "Hur kan vi hjälpa dig?",
            "sendRequest": "Skicka förfrågan",
            "thankYou": "Tack för ditt meddelande",
            "successText": "Vi har tagit emot dina uppgifter och återkommer så snart vi kan.",
            "backToForm": "Skicka ett nytt meddelande",
            "currentPropertiesLabel": "Aktuellt",

            "localTips": {
                "bgText": "VÄRDERING",
                "label": "Personlig Värdering",
                "title": "Går du i säljtankar?",
                "description": "Jag vet varför köpare väljer just Åhus. Låt mig berätta vad din bostad är värd i dagens marknad och hur vi bäst presenterar ditt hem för nästa ägare.",
                "button": "BOKA FRI VÄRDERING"
            },

            "loading": "Laddar",
            "livingArea": "Boyta",
            "price": "Pris",
            "currency": "kr",
            "operatingCost": "Driftkostnad",
            "floor": "Våningsplan",
            "info": "Info",
            "documents": "Dokument",
            "document": "Dokument",
            "description": "Beskrivning",
            "facts": "Fakta",
            "floorplan": "PLANLÖSNING",
            "upcomingViewing": "Snart visning",
            "upcoming": "Kommande",
            "sold": "Såld",
            "bidding": "Budgivning pågår",
            "responsibleAgent": "Ansvarig mäklare",
            "image": "Bild",
            "form_label": "Upplåtelseform",
            "buildYear": "Byggnadsår",
            "garden": "Tomt",
            "seeMoreSold": "Se fler sålda objekt",

            "philosophy": {
                "badge": "Min Filosofi",
                "bgText": "FILOSOFI",
                "quote": "\"Varje hem har en unik historia som förtjänar att berättas med omsorg.\"",
                "description": "För mig handlar fastighetsförmedling inte bara om kvadratmeter, utan om förtroende och hantverk. Genom att kombinera lokal expertis i Åhus med ett öga för detaljer, skapar vi de bästa förutsättningarna för din nästa affär.",
                "button": "LÄS MER OM MIG"
            },
            "nav": {
                "home": "Hem",
                "properties": "Förmedlingar",
                "philosophy": "Profil",
                "contact": "Kontakt",
                "sellWithUs": "Sälj med oss"
            },
            "valuation": {
                "label": "VÄRDERING",
                "title": "Går du i säljtankar?",
                "intro": "En lyckad försäljning börjar med en korrekt värdering. Vi hjälper dig att förstå marknadsvärdet på din bostad i dagens läge.",
                "quote": "Vi ser potentialen i varje hem och hjälper dig att nå rätt köpare.",
                "desc1": "Att sälja sin bostad är en av livets största affärer. Därför lägger vi stor vikt vid personligt engagemang och lokal kännedom.",
                "desc2": "Fyll i formuläret så kontaktar vi dig för ett förutsättningslöst möte där vi går igenom din bostads unika förutsättningar.",
                "signature": "Peter och teamet på Din Mäklare Åhus & Österlen",
                "formTitle": "Boka värdering",
                "formSub": "Lämna dina uppgifter så hörs vi av inom kort.",
                "successText": "Tack för din förfrågan! Vi har tagit emot dina uppgifter och återkommer till dig så snart som möjligt."
            },
            "form": {
                "name": "Namn",
                "email": "E-post",
                "phone": "Telefonnummer",
                "propertyType": "Typ av bostad",
                "selectType": "Välj typ av bostad",
                "send": "SKICKA FÖRFRÅGAN",
                "sending": "SKICKAR...",
                "messageLabel": "Information om bostaden",
                "messagePlaceholder": "Berätta gärna kort om bostaden (t.ex. antal rum, renoveringar)..."
            },
            "property": {
                "villa": "Villa",
                "apartment": "Bostadsrätt",
                "townhouse": "Radhus / Kedjehus",
                "cottage": "Fritidshus",
                "plot": "Tomt",
                "other": "Övrigt"
            },
            "peter": {
                "category": "Fastighetsmäklare",
                "name": "Peter Olvsborn",
                "heroSub": "Mäklaren som valde närvaro framför höjd.",
                "intro": {
                    "dropcap": "D",
                    "para1": "et börjar alltid med ljuset. För Peter Olvsborn är en fastighet inte bara en konstruktion av sten och trä, utan en scen där dagens timmar spelar ut sitt skådespel. Efter mer än tre decennier i branschen har han finslipat förmågan att se potentialen där andra ser problem.",
                    "para2": "Vi sitter i hans arbetsrum, ett avskalat rum där doften av nybryggt kaffe blandas med doften av gamla ritningar. Peter bläddrar tankfullt i en pärm. \"Folk har ofta bråttom,\" säger han. \"De ser ytskikt, köksöar och trendiga färgval. Men ett hus själ sitter i dess proportioner och hur det möter omgivningen.\"",
                    "para3": "Peters resa började långt ifrån de glättiga objektsbeskrivningarna i storstaden. Uppvuxen vid den skånska kusten lärde han sig tidigt att respektera material som åldras med värdighet. Denna respekt har blivit hans signum.",
                    "para4": "\"En bra affär handlar om harmoni. När säljaren känner att deras livsverk hamnar i rätt händer, och köparen känner att de har hittat sin plats på jorden – då har jag lyckats.\""
                },
                "pullQuote": "Vi säljer inte bostäder, vi kurerar framtida minnen.",
                "curating": {
                    "title": "Konsten att curera ett hem",
                    "para1": "I en digital värld där allt går fortare har Peter valt att sakta ner. Hans metodik bygger på personliga möten och en djup analys av varje enskilt objekt.",
                    "para2": "\"Jag vill skapa en atmosfär. Det kan handla om valet av musik som spelas svagt i bakgrunden, eller hur ljuset faller genom en specifik fönsternisch.\""
                },
                "qna": {
                    "title": "Korta frågor till Peter",
                    "q1": { "label": "Vad inspirerar dig mest just nu?", "answer": "Dansk modernism och hur man lyckas kombinera strikt minimalism med värme." },
                    "q2": { "label": "Ditt favoritmaterial?", "answer": "Oljad ek och natursten som fått en naturlig patina över tid." },
                    "q3": { "label": "Bästa platsen för återhämtning?", "answer": "Stranden i Åhus en tidig tisdagsmorgon i september." },
                    "q4": { "label": "Ett råd till blivande säljare?", "answer": "Våga rensa, men behåll själen. Ett hem ska kännas levt, inte som ett hotellrum." }
                },
                "footer": {
                    "title": "En personlig dialog",
                    "sub": "För diskussion om din nuvarande fastighet eller ditt nästa förvärv.",
                    "btn": "Boka ett möte"
                }
            },
            "peter2": {
                "introQuote": "”Jag fick välja, skulle jag bli en frånvarande pilotpappa eller en närvarande mäklarpappa”",
                "article": {
                    "para1": "eter Olvsborn är född och uppvuxen i Kristianstad, men har haft hus i Åhus sedan 1986, och långt innan dess ett fritidshus vid Yngsjö Havsbad. Efter gymnasiet började han läsa juridik i Lund med sikte på att bli företagsjurist. Men livet tog en annan riktning. Peter, som alltid älskat utförsåkning, valde att ta en paus från studierna och blev reseledare i Alperna för Fritidsresor.",
                    "para2": "— På den tiden fanns varken mobil eller mejl, utan det var fast telefoni och fax som gällde. Vi fick lösa allt på plats. Det var otroligt utvecklande och man lärde sig att känna av människor, berättar Peter.",
                    "para3": "Tre år som reseledare gav nya perspektiv och nya vänner. När en kompis reste till USA för att bli pilot, väcktes samma dröm hos Peter: Han åkte över och gick en ettårig utbildning på NAIA (North American Institute of Aviation) SAS-flygskola i USA. Dessutom utbildade han sig till flyglärare. Väl hemma i Sverige konverterade han sin utbildning för att kunna jobba som pilot här.",
                    "para4": "— Jag sökte en del jobb, men det var under Kuwaitkriget och tiden efter, och flygbranschen stod helt still. Det blev inga jobb, förklarar Peter. Hans mamma föreslog att han skulle ha fler krokar att hänga sin hatt på. Peter lyssnade, hoppade på mäklarutbildningen och tog examen 1988. Han startade eget och delade kontor med fastighetsförsäljaren Per Limé.",
                    "para5": "— Jag beundrade Per jättemycket. Han hade en enorm känsla för kunder och jag lärde mig otroligt mycket av honom. Efter en tid som egen företagare sökte Peter jobb på Malmöhusmäklarna. Han fortsatte driva sitt bolag parallellt och fick möjlighet att sälja både villor och lägenheter i Malmö.",
                    "para6": "Där och då lärde jag mig att aldrig döma människor efter utseende. Alla är lika mycket värda. Efter tiden i Malmö flyttade Peter tillbaka till Åhus och öppnade eget igen. Han valde närvaron. Peter köpte fastigheten på Köpmannagatan, där han än idag har sitt kontor.",
                    "sourceLabel": "Läs mer ur artikeln från",
                    "sourceName": "Vi syns i Åhus",
                    "sourceNumber": "nummer 184"
                }
            }

        }

    },
    en: {
        translation: {
            "contact": "Contact us",
            "sell": "Sell with us",
            "soldObjects": "Sold properties",
            "ourHomes": "Our homes",
            "heroTitle": "YOUR NEXT CHAPTER STARTS HERE",
            "heroSubtitle": "WE HELP YOU FIND MORE THAN JUST A HOUSE – WE FIND YOUR HOME",
            "heroButton": "OUR HOMES",
            "findHomeWhereLifeHappens": "FIND A HOME WHERE LIFE HAPPENS",
            "homeDescription": "We help you find a place to thrive. We offer both private and commercial properties and help you find the right fit – whether you are looking for a home, an investment, or new premises for your business.",
            "sold": "SOLD",
            "bidding": "BIDDING ONGOING",
            "upcomingViewing": "UPCOMING VIEWING",
            "upcoming": "COMING SOON",
            "rooms": "rooms",
            "moreProperties": "All properties",
            "aboutUsAlt": "About us – Real Estate Agency",
            "aboutUsTitle": "ABOUT US",
            "aboutUsParagraph1": "We are a local real estate agency with many years of experience and a genuine commitment to our clients.",
            "aboutUsParagraph2": "Our goal is to make the real estate transaction smooth, positive and memorable.",
            "aboutUsParagraph3": "With market expertise, thoroughness, and great commitment, we create the conditions for you.",
            "contactUsButton": "Contact us",
            "callConfirmation": "Do you want to call this number?",
            "teamMemberAlt": "Peter Olvsborn – Real Estate Agent",
            "companyLogoAlt": "Company Logo",
            "teamMemberName": "Peter Olvsborn",
            "teamMemberLabel": "Real estate agent",
            "teamMemberTitle": "Certified Real Estate Agent",
            "teamMemberPhone": "Tel: +46 (0) 708-240472",
            "teamReadMore": "Read more about Peter",

            "name": "Name",

       /*      "quote": "\"Receiving recommendations and positive feedback is both rewarding and motivating.\"",
            "name": "PETER OLVSBORN",
            "phone": "Phone",
            "email": "Email",
            "localKnowledgeTitle": "Local Expertise with Finesse",
            "localKnowledgeText": "With an office in the heart of Åhus on Köpmannagatan, I broker properties in one of Sweden’s most beautiful areas.",
            "joyAndRelationshipsTitle": "Joy in the Profession and Value of Relationships",
            "joyAndRelationshipsText": "To thrive in the real estate profession for over 37 years requires more than just competence.",
            "networkTitle": "A Network that Makes a Difference",
            "networkText": "The network I have built over the years is invaluable for you as a seller.",
            "trustTitle": "Trust that Lasts",
            "trustText": "My clients often return with questions or recommendations.",
            "honestyTitle": "Honesty Pays Off",
            "honestyText": "As a real estate agent, you must dare to be sincere.",
            "stylingTitle": "Styling Makes a Difference",
            "stylingText": "Small touches can make a big difference.",
            "timingTitle": "Right Timing",
            "timingText": "Timing is everything – show your home when it shines the most.",
            "proHelpTitle": "Professional Help Along the Way",
            "proHelpText": "A good real estate agent is like a good GPS.",
 */
            "info3ImageAlt": "Modern property",
            "info3Label": "Advice",
            "info3Title": "Discover Your Home’s Full Potential",
            "info3Paragraph1": "...and deserves to be shown from its best side. With the right preparations, you can increase the value and create the best possible conditions for a sale.",
            "info3Paragraph2": "Knowing which improvements actually pay off requires both experience and local market knowledge. We guide you through everything from furnishing tips to thoughts on room layout, ensuring your home is presented from its absolute best side. We are here to answer your questions – contact us today for a free valuation and strategic advice tailored to your specific needs.",

            "footerLogoAlt": "Din Maklare Logo",
            "aboutUs": "ABOUT US",
            "aboutUsText": "We are a local real estate agency with our heart in Åhus and many years of collective experience in the local property market. Our goal is to make your property journey as smooth, secure, and memorable as possible. By combining modern marketing, a broad network, and a genuine intuitive touch, we ensure you get the best value for your home, while helping you find the right place where the next chapter of life can begin.",
            "address": "Address",
            "addressText": "Köpmannagatan 15, 296 31 Åhus",
            "quickLinks": "QUICK LINKS",
            "home": "Home",
            "sellWithUs": "Sell With Us",
            "socialMedia": "SOCIAL MEDIA",
            "footerCopyright": "© 2026 Din Mäklare Åhus & Österlen. All rights reserved.",

            "currentProperties": "OUR CURRENT PROPERTIES",
            "exploreProperties": "Explore our selection of properties – find your dream home today.",
            "comingSoon": "COMING SOON",
            "contactUs": "CONTACT US",
            "contactHeroText": "We are here to help you with everything related to your property transaction.",
            "message": "Message",
            "messagePlaceholder": "How can we help you?",
            "sendRequest": "Send Request",
            "thankYou": "Thank you for your message",
            "successText": "We have received your details and will get back to you as soon as possible.",
            "backToForm": "Send another message",
            "currentPropertiesLabel": "On the market",

            "loading": "Loading",
            "livingArea": "Living Area",
            "price": "Price",
            "currency": "SEK",
            "operatingCost": "Operating Cost",
            "floor": "Floor",
            "info": "Info",
            "documents": "Documents",
            "document": "Document",
            "description": "Description",
            "facts": "Facts",
            "floorplan": "Floorplan",
           
            "responsibleAgent": "Responsible Agent",
            "image": "Image",
            "form_label": "Ownership type",
            "buildYear": "Year built",
            "garden": "Garden",
            "seeMoreSold": "SEE MORE",

            "localTips": {
                "bgText": "VALUATION",
                "label": "Personal Valuation",
                "title": "Thinking of selling?",
                "description": "I know why buyers choose Åhus specifically. Let me tell you what your home is worth in today's market and how we best present your home to the next owner.",
                "button": "BOOK FREE VALUATION"
            },

            "philosophy": {
                "badge": "My Philosophy",
                "bgText": "PHILOSOPHY",
                "quote": "\"Every home has a unique story that deserves to be told with care.\"",
                "description": "To me, real estate is about more than just square footage—it’s about trust and craftsmanship.",
                "button": "READ MORE ABOUT ME"
            },
            "nav": {
                "home": "Home",
                "properties": "Properties",
                "philosophy": "Profile",
                "contact": "Contact",
                "sellWithUs": "Sell with us"
            },
            "valuation": {
                "label": "VALUATION",
                "title": "Thinking of selling?",
                "intro": "A successful sale starts with an accurate valuation. We help you understand the market value of your home in today's market.",
                "quote": "We see the potential in every home and help you reach the right buyers.",
                "desc1": "Selling your home is one of life's biggest transactions. That's why we emphasize personal commitment and local knowledge.",
                "desc2": "Fill out the form and we will contact you for a no-obligation meeting to discuss your property's unique features.",
                "signature": "Peter and the team at Din Mäklare Åhus & Österlen",
                "formTitle": "Book a valuation",
                "formSub": "Leave your details and we'll be in touch shortly.",
                "successText": "Thank you for your inquiry! We have received your details and will get back to you shortly."
            },
            "form": {
                "name": "Name",
                "email": "Email",
                "phone": "Phone number",
                "propertyType": "Property type",
                "selectType": "Select property type",
                "send": "SEND REQUEST",
                "sending": "SENDING...",
                "messageLabel": "Property information",
                "messagePlaceholder": "Tell us briefly about the property..."
            },
            "property": {
                "villa": "Villa",
                "apartment": "Apartment",
                "townhouse": "Townhouse",
                "cottage": "Summer house",
                "plot": "Plot / Land",
                "other": "Other"
            },
            "peter": {
                "category": "Real Estate Agent",
                "name": "Peter Olvsborn",
                "heroSub": "The broker who chose presence over altitude.",
                "intro": {
                    "dropcap": "I",
                    "para1": "t always begins with the light. For Peter Olvsborn, a property is not just a construction of stone and wood, but a stage where the hours of the day play out their drama. After more than three decades in the industry, he has honed the ability to see potential where others see problems.",
                    "para2": "We sit in his study, a minimalist room where the scent of freshly brewed coffee mixes with that of old blueprints. Peter thoughtfully flips through a binder. \"People are often in a hurry,\" he says. \"They see surfaces, kitchen islands, and trendy color choices. But a house's soul lies in its proportions and how it meets its surroundings.\"",
                    "para3": "Peter's journey began far from the glossy object descriptions of the big city. Raised on the Scanian coast, he learned early on to respect materials that age with dignity. This respect has become his hallmark.",
                    "para4": "\"A good deal is about harmony. When the seller feels that their life's work is in the right hands, and the buyer feels they have found their place on earth – then I have succeeded.\""
                },
                "pullQuote": "We don't sell homes, we curate future memories.",
                "curating": {
                    "title": "The Art of Curating a Home",
                    "para1": "In a digital world where everything moves faster, Peter has chosen to slow down. His methodology is based on personal meetings and a deep analysis of each individual object.",
                    "para2": "\"I want to create an atmosphere. It can be about the choice of music playing softly in the background, or how the light falls through a specific window niche.\""
                },
                "qna": {
                    "title": "Short questions for Peter",
                    "q1": { "label": "What inspires you most right now?", "answer": "Danish modernism and how to combine strict minimalism with warmth." },
                    "q2": { "label": "Your favorite material?", "answer": "Oiled oak and natural stone that has gained a natural patina over time." },
                    "q3": { "label": "Best place for recovery?", "answer": "The beach in Åhus on an early Tuesday morning in September." },
                    "q4": { "label": "Advice for future sellers?", "answer": "Dare to declutter, but keep the soul. A home should feel lived in, not like a hotel room." }
                },
                "footer": {
                    "title": "A personal dialogue",
                    "sub": "For discussion regarding your current property or your next acquisition.",
                    "btn": "Book a meeting"
                }
            },
            "peter2": {
                "introQuote": "“I had to choose: would I be an absent pilot father or a present real estate father?”",
                "article": {
                    "para1": "eter Olvsborn was born and raised in Kristianstad, but has owned a home in Åhus since 1986, and long before that, a summer house by Yngsjö Havsbad. After high school, he began studying law in Lund with the aim of becoming a corporate lawyer. However, life took a different turn. Peter, who has always loved downhill skiing, chose to take a break from his studies to become a tour guide in the Alps for Fritidsresor.",
                    "para2": "— Back then, there were neither mobiles nor emails; it was landlines and faxes that applied. We had to solve everything on the spot. It was incredibly character-building, and you learned how to read people, Peter explains.",
                    "para3": "Three years as a tour guide provided new perspectives and new friends. When a friend traveled to the USA to become a pilot, the same dream was sparked in Peter: He went over and completed a one-year training program at the NAIA (North American Institute of Aviation) SAS flight school in the USA. Additionally, he trained as a flight instructor. Once back in Sweden, he converted his license to be able to work as a pilot here.",
                    "para4": "— I applied for several jobs, but it was during the Kuwait War and the period following, and the aviation industry was completely at a standstill. There were no jobs, Peter explains. His mother suggested he should have more 'hooks to hang his hat on.' Peter listened, joined the real estate program, and graduated in 1988. He started his own business, sharing an office with real estate salesman Per Limé.",
                    "para5": "— I admired Per immensely. He had an enormous feel for customers, and I learned a great deal from him. After a period as a business owner, Peter sought a position at Malmöhusmäklarna. He continued to run his company in parallel and had the opportunity to sell both villas and apartments in Malmö.",
                    "para6": "It was there and then I learned never to judge people by appearances. Everyone is of equal value. After his time in Malmö, Peter moved back to Åhus and opened his own business again. He chose presence. Peter purchased the property on Köpmannagatan, where he still has his office today.",

                    "sourceLabel": "Read more from the article in",
                    "sourceName": "Vi syns i Åhus",
                    "sourceNumber": "issue 184"

                }
                
            }
        }
    }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "sv",
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;